import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { environment } from '../../environments/environment';

type FeatureName = keyof typeof environment.features;

/**
 * Blocks a route when its feature switch is off.
 *
 * Hiding the button alone is not enough: these routes are reachable by typing the URL, and
 * bookmarks to them survive the feature being switched off. Guarding the route keeps the
 * navigation entry and the page itself governed by the same single flag.
 */
export function featureGuard(feature: FeatureName): CanActivateFn {
  return () => {
    if (environment.features[feature]) return true;

    // Send the user somewhere real rather than leaving a blank screen.
    return inject(Router).createUrlTree(['/dashboard']);
  };
}
